import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { TABLE_DEFAULT_BORDER_TYPE, TABLE_DEFAULT_SIZE, TABLE_DEFAULT_WIDTH, TABLE_DEFAULT_ZEBRA } from './Table.constants';
import { TableRoot, TableWrapper } from './Table.styled';
// Component.
// -----------------------------------------------------------------------------
const Table = forwardRef(({ children, borderType = TABLE_DEFAULT_BORDER_TYPE, width = TABLE_DEFAULT_WIDTH, size = TABLE_DEFAULT_SIZE, zebra = TABLE_DEFAULT_ZEBRA, ...rest }, ref) => {
    // Render.
    // -------------------------------------------------------------------------
    return (_jsx(TableWrapper, { children: _jsx(TableRoot, { ref: ref, borderType: borderType, width: width, size: size, zebra: zebra, ...rest, children: children }) }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Table.displayName = 'Table';
export default Table;
//# sourceMappingURL=Table.js.map